import { Layers } from 'lucide-react';
import type { ReactNode } from 'react';
import type { EditUnit } from 'v5/core/entity-schema/entitySchema.types';
import { resourceSpecIcon } from 'v5/patterns/resource/resourceFieldIcons';

/**
 * The icon before a resource unit's title, as its column, filter and the
 * field finder show it: a field group's blocks icon, else its field's.
 */
export function renderResourceUnitIcon(unit: EditUnit): ReactNode {
  if (unit.container.type === 'custom-field-group') return <Layers />;
  const [spec] = unit.type === 'list' ? unit.item.fields : unit.fields;
  if (spec === undefined) return null;
  const Icon = resourceSpecIcon(spec);
  return <Icon />;
}
